import { Vector2 } from 'three'
import { Terrain } from '../../../../d.controllers/TerrainController'
import GameObject from '../../../GameElements/classes/GameObject'
import { GAME_OBJECTS } from '../../../GameElements/classes/types'

const getObjectsInRange = (objectClasses: GAME_OBJECTS[], range: Vector2[]):GameObject[] => {
  const found = range.reduce((res: GameObject[], coords) => {
    const el = Terrain.getElementAt(coords)
    const matchClass = objectClasses.find(oClass => el?.isClass(oClass))
    if (matchClass && el) {
      res.push(el)
    }
    return res
  }, [])

  return found
}
export default getObjectsInRange
